import { useCallback } from 'react';

import { fetchEnvAction } from '../apiActions/fetchEnvAction';
import { useCoreDispatch } from '../CoreStore';
import { useConfigSlice } from '../slices/config/selectors';

export const useEnvFetcher = (essential: boolean): (() => void) => {
  const dispatch = useCoreDispatch();
  const JSESSIONID = useConfigSlice.JSESSIONID();
  const baseUrl = useConfigSlice.baseUrl();

  return useCallback(() => {
    if (JSESSIONID && baseUrl) {
      dispatch(
        fetchEnvAction({
          url: baseUrl,
          JSESSIONID,
          essential,
        })
      );
    }
  }, [JSESSIONID, baseUrl, dispatch, essential]);
};
